import { render, staticRenderFns } from "./OrderPrintItem.vue?vue&type=template&id=22828774&scoped=true&"
import script from "./OrderPrintItem.vue?vue&type=script&lang=js&"
export * from "./OrderPrintItem.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/order/OrderPrintItem/OrderPrintItemStyle.css?vue&type=style&index=0&id=22828774&scoped=true&lang=css&"
import style1 from "./OrderPrintItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22828774",
  null
  
)

export default component.exports